var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"C-fragment C-fragment-html C-fragment-html-md-heading"},[_c('div',{class:`C-title C-title__${_vm.headlineClass}`,domProps:{"innerHTML":_vm._s(_vm.headlineText)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }